import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { invalidateRbacQueriesPredicate } from '../rbac/_utils';

const apiFn = apiClient.enterprises.addUserToChildOrganization;

type RequestPayload = Parameters<
  typeof apiFn
>[0]['addUserToChildOrganizationRequest'];

export const useAddUserToChildOrganizationMutation = () => {
  const { enterpriseOrgId } = useOrganizations();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Omit<RequestPayload, 'enterpriseId'>) => {
      return apiFn(
        {
          enterpriseId: enterpriseOrgId!,
          addUserToChildOrganizationRequest: {
            ...payload,
            enterpriseId: enterpriseOrgId!,
          },
        },
        {
          headers: overrideOrganizationHeader(enterpriseOrgId),
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: invalidateRbacQueriesPredicate,
      });
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
